import { useQuery } from '@tanstack/react-query';

import { reportQueries } from '#reports';

export function useReports() {
  return useQuery(reportQueries.list());
}
